var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "HKLSelect",
    _vm._g(
      _vm._b(
        {
          attrs: {
            mode: "multiple",
            defaultValue: _vm.defaultValue,
            options: _vm.proxyOptions,
            maxVisibleOptions: _vm.maxVisibleOptions,
            respectOptionDisabled: _vm.respectOptionDisabled,
          },
          model: {
            value: _vm.proxyValue,
            callback: function ($$v) {
              _vm.proxyValue = $$v
            },
            expression: "proxyValue",
          },
        },
        "HKLSelect",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }